/**
 * AlmadarPostWelcomeToAlmadarSLPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostWelcomeToAlmadarSLPostPage
 */

import { useAlmadarPostWelcomeToAlmadarSLPostPageLogic } from '@/hooks/traits/useAlmadarPostWelcomeToAlmadarSLPostPageLogic';
import type { AlmadarPostWelcomeToAlmadarSLPostPageConfig } from '@/hooks/traits/useAlmadarPostWelcomeToAlmadarSLPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostWelcomeToAlmadarSLPostView as AlmadarPostWelcomeToAlmadarSLPostViewEntity } from '@app/shared';
import { AlmadarPostWelcomeToAlmadarSLPostFooterView } from '@/components/traits/AlmadarPostWelcomeToAlmadarSLPostFooterView';
import { Box } from '@almadar/ui/components';
import { AlmadarPostWelcomeToAlmadarSLPostView } from '@/components/traits/AlmadarPostWelcomeToAlmadarSLPostView';
import { AlmadarPostWelcomeToAlmadarSLPostHeaderView } from '@/components/traits/AlmadarPostWelcomeToAlmadarSLPostHeaderView';
import { Stack } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostWelcomeToAlmadarSLPostPageViewProps {
  config?: Partial<AlmadarPostWelcomeToAlmadarSLPostPageConfig>;
}

export function AlmadarPostWelcomeToAlmadarSLPostPageView({ config: propsConfig }: AlmadarPostWelcomeToAlmadarSLPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostWelcomeToAlmadarSLPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostWelcomeToAlmadarSLPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostWelcomeToAlmadarSL" trait="AlmadarPostWelcomeToAlmadarSLPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostWelcomeToAlmadarSLPostPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><AlmadarPostWelcomeToAlmadarSLPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" fullWidth={true} paddingY="xl"><Container maxWidth="xl" size="xl" padding="lg"><AlmadarPostWelcomeToAlmadarSLPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostWelcomeToAlmadarSLPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostWelcomeToAlmadarSLPostPageView;
